module.exports = __webpack_public_path__ + "img/icon-failed-outline.bd9eeab3.svg";